module.exports = __webpack_public_path__ + "static/media/homenagem-capela.06f20fb6.webp";